@if (!StringUtils.isEmpty(quotation())) {
<div class="pt-[20px]">
  <div class="bg-[#ECFFDC] m-auto max-w-[500px] rounded-md shadow-md p-[20px] mx-auto">
    <div class="mb-[15px] text-center">
      <svg class="text-center m-auto text-[green]" width="5.2em" height="5.2em" viewBox="0 0 24 24">
        <path fill="currentColor" fill-rule="evenodd"
          d="M5.5 1a.5.5 0 0 0-.477.65l.11.35H3.5a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5h-1.632l.11-.35A.5.5 0 0 0 10.5 1zm.68 1h3.64l-.313 1H6.493zm1.674 8.854l3.5-3.5l-.707-.708L7.5 9.793L5.854 8.146l-.708.708l2 2a.5.5 0 0 0 .708 0"
          clip-rule="evenodd" />
      </svg>
    </div>
    <div class="text-center text-[25px] font-semibold mb-[15px]">
      Your quote has been successfully submitted.
    </div>
    <div class="text-center m-auto shadow-sm p-2 mb-[20px] text-sm text-yellow-800 font-semibold">
      Our team will contact you shortly.
    </div>
    <div class="flex gap-[10px] items-center mx-auto justify-center">
      <button (click)="performAction(actionButtons?.homePage?.action)"
        class="bg-[#F94D00] text-[14px] rounded-[100px] pl-[10px] pr-[10px] pt-[10px] pb-[10px] text-center text-[#FFFFFF] h-[45px] w-[200px] font-semibold uppercase">
        {{ actionButtons?.homePage?.title }}
      </button>
      <button (click)="redirectToQuote()"
        class="bg-[#10ac37] text-[14px] rounded-[100px] pl-[10px] pr-[10px] pt-[10px] pb-[10px] text-center text-[#FFFFFF] h-[45px] w-[200px] font-semibold uppercase">
        {{ actionButtons?.quotePage?.title }}
      </button>
    </div>
  </div>
</div>
} @else {


<!-- v1 top section -->
<section class="relative mx-[calc(50%-50vw)] w-screen overflow-hidden border-b border-slate-200 bg-white">
  <!-- orange left accent bar (visible lg+) -->
  <span class="absolute inset-y-0 left-0 hidden w-1 bg-[#F86610] lg:block" aria-hidden="true"></span>

  <div class="relative mx-auto w-full max-w-[1500px] px-5 py-5 md:px-8 md:py-6 lg:pl-10">
    <div class="flex flex-col gap-5 lg:flex-row lg:items-center lg:gap-8">

      <!-- LEFT: badge · headline · tagline · CTA -->
      <div class="flex min-w-0 flex-1 flex-col justify-center gap-3">
        <div class="flex flex-wrap items-center gap-2">
          <span
            class="inline-flex items-center gap-2 rounded-full border-2 border-[#d88935] bg-orange-50 px-3 py-0.5 text-[11px] font-bold uppercase tracking-[0.18em] text-orange-600 shadow-[inset_0_0_0_1px_#d88935]">
            <span class="h-1.5 w-1.5 rounded-full bg-orange-500"></span>Smart Quotation
          </span>
          <span
            class="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 px-3 py-0.5 text-[11px] font-medium text-slate-600">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="h-3 w-3 text-orange-500" aria-hidden="true">
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M12 6v6l4 2"></path>
            </svg>Tailored quote in 24 hours
          </span>
        </div>

        <h1 class="text-[1.6rem] font-extrabold leading-tight tracking-tight text-slate-900 md:text-[1.9rem]">
          Get the best deal when you,
          <span class="relative inline-block md:whitespace-nowrap" style="color: #F86610;">Request a Quote
            <span aria-hidden="true"
              class="absolute -bottom-1 left-0 h-1.5 w-full rounded-full bg-gradient-to-r from-orange-400/70 to-orange-300/30"></span>
          </span>
        </h1>

        <p class="text-sm leading-relaxed text-black">Submit your Request to unlock special discount.</p>
       
      </div>

      <!-- RIGHT: 2×2 feature grid -->
      <div class="hidden lg:grid self-start shrink-0 grid-cols-2 gap-3 lg:w-[660px]">
        <!-- card 1 -->
        <div class="group relative overflow-hidden rounded-xl border border-slate-200 bg-white px-4 py-2 pt-3.5 shadow-[0_1px_3px_rgba(15,42,72,0.12),0_8px_20px_-16px_rgba(15,42,72,0.35)] transition-all hover:-translate-y-0.5 hover:shadow-[0_8px_20px_-14px_rgba(15,42,72,0.36)]">
          <span class="absolute inset-x-0 top-0 h-1 bg-orange-400"></span>
          <div class="flex items-center gap-3">
            <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-slate-900">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="h-4 w-4 text-white" aria-hidden="true">
                <path d="m21 21-4.34-4.34"></path>
                <circle cx="11" cy="11" r="8"></circle>
              </svg>
            </span>
            <div>
              <p class="text-sm font-bold text-slate-900">No More Searching or Comparing</p>
              <p class="mt-0.5 text-xs leading-snug text-black">Upload once — we handle the rest.</p>
            </div>
          </div>
        </div>
        <!-- card 2 -->
        <div class="group relative overflow-hidden rounded-xl border border-slate-200 bg-white px-4 py-2 pt-3.5 shadow-[0_1px_3px_rgba(15,42,72,0.12),0_8px_20px_-16px_rgba(15,42,72,0.35)] transition-all hover:-translate-y-0.5 hover:shadow-[0_8px_20px_-14px_rgba(15,42,72,0.36)]">
          <span class="absolute inset-x-0 top-0 h-1 bg-emerald-500"></span>
          <div class="flex items-center gap-3">
            <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-emerald-700">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="h-4 w-4 text-white" aria-hidden="true">
                <path d="M6 3h12"></path>
                <path d="M6 8h12"></path>
                <path d="m6 13 8.5 8"></path>
                <path d="M6 13h3"></path>
                <path d="M9 13c6.667 0 6.667-10 0-10"></path>
              </svg>
            </span>
            <div>
              <p class="text-sm font-bold text-slate-900">Better Prices, Without the Effort</p>
              <p class="mt-0.5 text-xs leading-snug text-black">Competitive pricing and Rate lock for up to <span class="font-bold text-emerald-700">30 days</span>.</p>
            </div>
          </div>
        </div>
        <!-- card 3 -->
        <div class="group relative overflow-hidden rounded-xl border border-slate-200 bg-white px-4 py-2 pt-3.5 shadow-[0_1px_3px_rgba(15,42,72,0.12),0_8px_20px_-16px_rgba(15,42,72,0.35)] transition-all hover:-translate-y-0.5 hover:shadow-[0_8px_20px_-14px_rgba(15,42,72,0.36)]">
          <span class="absolute inset-x-0 top-0 h-1 bg-rose-500"></span>
          <div class="flex items-center gap-3">
            <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-rose-800">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="h-4 w-4 text-white" aria-hidden="true">
                <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                <path d="m9 12 2 2 4-4"></path>
              </svg>
            </span>
            <div>
              <p class="text-sm font-bold text-slate-900">Reliable Supply You Can Trust</p>
              <p class="mt-0.5 text-xs leading-snug text-black">One Price for Multi-Location Delivery</p>
            </div>
          </div>
        </div>
        <!-- card 4 -->
        <div class="group relative overflow-hidden rounded-xl border border-slate-200 bg-white px-4 py-2 pt-3.5 shadow-[0_1px_3px_rgba(15,42,72,0.12),0_8px_20px_-16px_rgba(15,42,72,0.35)] transition-all hover:-translate-y-0.5 hover:shadow-[0_8px_20px_-14px_rgba(15,42,72,0.36)]">
          <span class="absolute inset-x-0 top-0 h-1 bg-blue-500"></span>
          <div class="flex items-center gap-3">
            <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-blue-700">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="h-4 w-4 text-white" aria-hidden="true">
                <path d="M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z"></path>
                <path d="m7 16.5-4.74-2.85"></path><path d="m7 16.5 5-3"></path><path d="M7 16.5v5.17"></path>
                <path d="M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z"></path>
                <path d="m17 16.5-5-3"></path><path d="m17 16.5 4.74-2.85"></path><path d="M17 16.5v5.17"></path>
                <path d="M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z"></path>
                <path d="M12 8 7.26 5.15"></path><path d="m12 8 4.74-2.85"></path><path d="M12 13.5V8"></path>
              </svg>
            </span>
            <div>
              <p class="text-sm font-bold text-slate-900">One Platform, One Vendor</p>
              <p class="mt-0.5 text-xs leading-snug text-black">One stop shop for all your needs</p>
            </div>
          </div>
        </div>
      </div>

    </div>
     <!-- process steps inline -->
        <div class="flex flex-row flex-nowrap items-center gap-x-3 overflow-x-auto border-t border-slate-200/70 pt-3 py-1 lg:flex-wrap lg:justify-center lg:gap-x-5 lg:gap-y-0 lg:overflow-visible">
          <div class="flex shrink-0 items-center gap-2 text-xs font-medium text-black">
            <span class="flex h-5 w-5 items-center justify-center rounded-full bg-orange-500 text-[10px] font-bold text-white">1</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-3.5 w-3.5 text-slate-400" aria-hidden="true"><path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path><path d="M14 2v5a1 1 0 0 0 1 1h5"></path></svg>
            Raise Requirement
            <svg class="hidden lg:block h-3.5 w-3.5 text-slate-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
          </div>
          <!-- down arrow: mobile only -->
          <svg class="hidden h-3.5 w-3.5 text-slate-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 5v14"/><path d="m19 12-7 7-7-7"/></svg>
          <div class="flex shrink-0 items-center gap-2 text-xs font-medium text-black">
            <span class="flex h-5 w-5 items-center justify-center rounded-full bg-orange-500 text-[10px] font-bold text-white">2</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-3.5 w-3.5 text-slate-400" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><path d="M12 6v6l4 2"></path></svg>
            Receive Quote within 24 hours
            <svg class="hidden lg:block h-3.5 w-3.5 text-slate-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
          </div>
          <!-- down arrow: mobile only -->
          <svg class="hidden h-3.5 w-3.5 text-slate-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 5v14"/><path d="m19 12-7 7-7-7"/></svg>
          <div class="flex shrink-0 items-center gap-2 text-xs font-medium text-black">
            <span class="flex h-5 w-5 items-center justify-center rounded-full bg-orange-500 text-[10px] font-bold text-white">3</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-3.5 w-3.5 text-slate-400" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><path d="m9 12 2 2 4-4"></path></svg>
            Select & Approve Product
            <svg class="hidden lg:block h-3.5 w-3.5 text-slate-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
          </div>
          <!-- down arrow: mobile only -->
          <svg class="hidden h-3.5 w-3.5 text-slate-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 5v14"/><path d="m19 12-7 7-7-7"/></svg>
          <div class="flex shrink-0 items-center gap-2 text-xs font-medium text-black">
            <span class="flex h-5 w-5 items-center justify-center rounded-full bg-orange-500 text-[10px] font-bold text-white">4</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-3.5 w-3.5 text-slate-400" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"></path><path d="M15 18H9"></path><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path><circle cx="17" cy="18" r="2"></circle><circle cx="7" cy="18" r="2"></circle></svg>
            Door step Delivery
          </div>
        </div>
  </div>
</section>
<!-- new top section / -->

<!--form section list-->
<div id="smartbuy-form" class="py-5 md:px-[0px] px-[10px]">
  <!-- card 1 -->
  <!-- <div
      class="shadow-md bg-[#ffffff] rounded-[5px] mb-[20px] p-[20px] max-w-[1200px] mx-auto"
    >
      <div
        class="md:py-[20px] md:px-[80px] flex flex-col md:flex-row items-center justify-center md:gap-[60px] gap-[20px] text-center md:text-start"
      >
        <div class="text-[#162F4D] font-[600] md:text-[23px] text-[20px]">
          <div class="md:w-[350px]">
            {{ constants()?.infoTitle }}
          </div>
        </div>
        <div
          class="bg-[#DFDFDF] md:w-[1px] md:h-[100px] w-[100px] h-[1px]"
        ></div>
        <div
          class="md:text-[18px] text-[16px] text-[#000000] grow"
          [innerHTML]="constants()?.infoDesc"
        ></div>
      </div>
    </div> -->
  <!-- card 1 /-->
  <!-- tabs -->
  <div class="mb-[20px] flex justify-center">
    <div class="bg-[#ffffff] shadow-md p-[5px] rounded-[50px] md:w-[500px] w-full grid grid-cols-2 gap-[10px]">
      <div (click)="changeTab(true)" class="cursor-pointer">
        <div [ngClass]="{
              'bg-[#F94D00] text-[#ffffff]': fillQuote(),
              'bg-[#F4F6F8] text-[#000000]': !fillQuote(),
            }" class="flex min-h-[45px] items-center justify-center px-[10px] text-center rounded-full font-semibold md:text-[16px] text-[13px]">
          {{ constants()?.fillUploadType }}
        </div>
      </div>
      <div (click)="changeTab(false)" class="cursor-pointer">
        <div [ngClass]="{
              'bg-[#F94D00] text-[#ffffff]': !fillQuote(),
              'bg-[#F4F6F8] text-[#000000]': fillQuote(),
            }" class="flex min-h-[45px] items-center justify-center px-[10px] text-center rounded-full font-semibold md:text-[16px] text-[13px]">
          {{ constants()?.templateUploadType }}
        </div>
      </div>
    </div>
  </div>
  <!-- tabs /-->
  <!--form section start here-->
  <div class="shadow-md bg-[#ffffff] rounded-[5px] mb-[20px] p-[20px] max-w-[1200px] mx-auto">
    <form [formGroup]="userQuoteForm" (ngSubmit)="handleSubmit()">
      <div>
        <div [ngClass]="{ '': fillQuote() }" class="mb-[20px]">
          <!-- <form class="w-full"> -->
          @if (!fillQuote()) {
          <div class="">
            <div class="text-[#F94D00] md:text-[20px] text-[18px] font-[600] mb-[15px]">
              {{ constants()?.tableHeading }}
            </div>
            <label
              class="relative h-[200px] items-center flex cursor-pointer appearance-none justify-center rounded-md border border-dashed border-[#162F4D] px-3 py-6 text-sm transition hover:border-[#F94D00] focus:border-solid disabled:cursor-not-allowed disabled:bg-gray-200 disabled:opacity-75"
              tabindex="0">
              <span for="photo-dropbox" class="flex flex-col items-center space-x-2">
                <div>
                  <svg class="h-[60px] w-[60px] stroke-gray-400" viewBox="0 0 256 256">
                    <path d="M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7" fill="none" stroke-linecap="round"
                      stroke-linejoin="round" stroke-width="24"></path>
                    <path d="M80,128a80,80,0,1,1,144,48" fill="none" stroke-linecap="round" stroke-linejoin="round"
                      stroke-width="24"></path>
                    <polyline points="118.1 161.9 152 128 185.9 161.9" fill="none" stroke-linecap="round"
                      stroke-linejoin="round" stroke-width="24"></polyline>
                    <line x1="152" y1="208" x2="152" y2="128" fill="none" stroke-linecap="round" stroke-linejoin="round"
                      stroke-width="24"></line>
                  </svg>
                </div>
                <div class="text-lg font-medium text-gray-600">
                  {{ fileName() ? fileName() : 'Upload quotes product list'
                  }}
                  @if (StringUtils.isEmpty(fileName())) {
                  <span class="text-[red]">*</span>
                  }
                </div>
                <div class="text-[#BCBCBC] text-[14px]">
                  JPEG, PNG, PDF, DOC, XLS, XLSX, CSV
                </div>
                @if (fileName()) {
                <div class="text-[#0caf27] text-3xl w-5">&#x2713;</div>
                }
              </span>
              <br />
              @if(StringUtils.isEmpty(fileName()) && fileUploadStatus()) {
              <p class="text-[red] text-md absolute bottom-70 m-auto pt-2">
                {{ fileUploadStatus() }}
              </p>
              }
              <!-- <span class="text-blue-600 underline">browse</span> -->
              <input [accept]="fileUploadType()" [disabled]="fileName()" (change)="uploadFile($event)" type="file"
                class="sr-only disabled:cursor-not-allowed disabled:bg-gray-200 disabled:opacity-75" />
            </label>
          </div>
          } @else {
          <div class="">
            <div class="text-[#F94D00] md:text-[20px] text-[18px] font-[600] mb-[15px]">
              Fill your Quotes
            </div>
            <!-- t head -->
            <div class="md:flex hidden gap-[2px] text-[#5B5B5B] text-[15px] bg-[#DFECFF] font-[600]">
              <div>
                <div class="w-[60px] p-[10px]">S.No</div>
              </div>
              <div class="grow">
                <div class="grid grid-cols-4 gap-[10px] uppercase">
                  <div class="p-[10px]">{{ constants()?.brand }}</div>
                  <div class="p-[10px]">
                    {{ constants()?.productDescription }}
                    <span class="text-[#ff0000]">*</span>
                  </div>
                  <div class="p-[10px]">{{ constants()?.targetPrice }}</div>
                  <div class="p-[10px]">
                    {{ constants()?.reqQty }}
                    <span class="text-[#ff0000]">*</span>
                  </div>
                </div>
              </div>
              <div>
                <div class="w-[60px]"></div>
              </div>
            </div>
            <!-- t head  / -->
            <div class="md:max-h-[265px] max-h-[400px] overflow-y-auto">
              <div formArrayName="quotationItems">
                <!-- row re -->
                <div *ngFor="let row of quotationItems.controls; let i = index" [formGroupName]="i"
                  class="flex md:flex-nowrap flex-wrap gap-[2px] md:bg-transparent bg-[#F4F6F8] rounded-[5px] md:mb-[0px] mb-[15px]">
                  <div
                    class="flex items-center text-center md:shrink grow md:bg-transparent bg-[#DFECFF] rounded-t-[5px]">
                    <div class="md:w-[60px] w-full p-[10px]">
                      {{ i + 1 }}
                    </div>
                  </div>
                  <div class="md:grow w-full">
                    <div class="grid md:grid-cols-4 grid-cols-1 md:gap-[10px] gap-[0px] uppercase">
                      <div class="p-[10px]">
                        <div class="md:hidden block mb-[5px] text-[13px] text-[#5B5B5B]">
                          {{ constants()?.brand }}
                        </div>
                        <input formControlName="brand" type="text"
                          class="w-full border-solid border-[1px] rounded-md border-[#BCBCBC] px-3 py-3 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-1 focus:border-gray-900 focus:border-t-transparent focus:!border-t-gray-900 focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50" />
                        @if (row?.get('brand')?.errors?.['maxlength'] && row?.get('brand')?.touched) {
                        <div>
                          <span class="m-auto text-red-500 text-[10px] font-medium lowercase">
                            Brand may have exceeded the character limit,
                            please add not more than 150 characters</span>
                        </div>
                        }
                      </div>
                      <div class="p-[10px]">
                        <div class="md:hidden block mb-[5px] text-[13px] text-[#5B5B5B]">
                          {{ constants()?.productDescription }}
                          <span class="text-[red]">*</span>
                        </div>
                        <input formControlName="description" type="text"
                          class="w-full border-solid border-[1px] border-[#BCBCBC] rounded-md px-3 py-3 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-1 focus:border-gray-900 focus:border-t-transparent focus:!border-t-gray-900 focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50" />

                        <div>
                          @if (row?.get('description')?.errors?.['maxlength'] && row?.get('description')?.touched) {
                          <span class="m-auto text-red-500 text-[10px] font-medium lowercase">
                            Description exceeded the character limit, please
                            add not more than 150 characters</span>
                          }
                          @if (row?.get('description')?.errors?.['required'] && row?.get('description')?.touched) {
                          <span class="m-auto text-red-500 text-[10px] font-medium lowercase">
                            Description is required</span>
                          }
                        </div>
                      </div>
                      <div class="p-[10px]">
                        <div class="md:hidden block mb-[5px] text-[13px] text-[#5B5B5B]">
                          {{ constants()?.targetPrice }}
                        </div>
                        <input (input)="validateInput($event, 'price', i)" formControlName="targetPrice" type="text"
                          class="w-full border-solid border-[1px] rounded-md border-[#BCBCBC] px-3 py-3 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-1 focus:border-gray-900 focus:border-t-transparent focus:!border-t-gray-900 focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50" />
                      </div>
                      <div class="p-[10px]">
                        <div class="md:hidden block mb-[5px] text-[13px] text-[#5B5B5B]">
                          {{ constants()?.reqQty }}
                          <span class="text-[red]">*</span>
                        </div>
                        <input (input)="validateInput($event, 'quantity', i)" formControlName="quantity" type="text"
                          class="w-full border-solid border-[1px] border-[#BCBCBC] rounded-md px-3 py-3 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-1 focus:border-gray-900 focus:border-t-transparent focus:!border-t-gray-900 focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50" />
                        <div>
                          @if (row?.get('quantity')?.errors?.['pattern'] && row?.get('quantity')?.touched) {
                          <span class="m-auto text-red-500 text-[10px] font-medium lowercase">
                            Quantity is required</span>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="flex items-center md:shrink md:w-auto w-full justify-center">
                    <div class="md:w-[60px] w-full flex justify-center md:pb-[0px] pb-[10px]">
                      @if(i > 0){
                      <div class="cursor-pointer" (click)="deleteTableRow(i)">
                        <img src="https://static3.industrybuying.com/a-wk/images/svg/trash.svg" />
                      </div>
                      }
                    </div>
                  </div>
                </div>
                <div>
                  @if (disabledAddButton()) {
                  <div class="my-[10px] text-red-500 font-normal text-center">
                    Please fill all the required fields before adding a new
                    row!
                  </div>
                  }
                </div>
                <!-- row re / -->
              </div>
            </div>
            <div class="pt-[0px] ml-auto table mb-[20px]">
              <button (click)="addTableRow()" type="button"
                class="bg-[#162F4D] text-[#ffffff] py-[15px] px-[25px] text-center rounded-[5px] font-semibold text-[16px]">
                Add Row
              </button>
            </div>
            <div class="border-[#a5a5a5] border border-dashed"></div>
          </div>
          }
          <!-- </form>   -->
        </div>
        <div class="grid md:grid-cols-3 grid-cols-1 gap-[20px] mb-[20px]">
          <div>
            <label class="mb-[5px] text-[13px] text-[#5B5B5B]">Name<span class="text-[red]">*</span></label>
            <input type="text" formControlName="name"
              class="w-full border-solid border-[1px] mt-[8px] rounded-md border-[#BCBCBC] px-3 py-3 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-1 focus:border-gray-900 focus:border-t-transparent focus:!border-t-gray-900 focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50" />
            @if(userQuoteForm?.get('name')?.invalid && userQuoteForm?.get('name')?.touched){
            <div>
              @if(userQuoteForm?.get('name')?.errors?.['pattern']){
              <small class="text-red-500 text-[12px]">Name must contain only alphabets.</small>
              } @else if(userQuoteForm?.get('name')?.errors?.['minlength']){
              <small class="text-red-500 text-[12px]">Name must be at least 3 characters.</small>
              } @else if(userQuoteForm?.get('name')?.errors?.['maxlength']){
              <small class="text-red-500 text-[12px]">Name cannot exceed 100 characters.</small>
              } @else {
              <small class="text-red-500 text-[12px]">Name is required.</small>
              }
            </div>
            }
          </div>
          <div>
            <label class="mb-[5px] text-[13px] text-[#5B5B5B]">Mobile No<span class="text-[red]">*</span></label>
            <input type="text" formControlName="mobile"
              class="w-full border-solid border-[1px] mt-[8px] rounded-md border-[#BCBCBC] px-3 py-3 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-1 focus:border-gray-900 focus:border-t-transparent focus:!border-t-gray-900 focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50" />
            @if(userQuoteForm?.get('mobile')?.invalid && userQuoteForm?.get('mobile')?.touched){
            <div>
              <small class="text-red-500 text-[12px]">Mobile number is required and must be 10 digits.</small>
            </div>
            }
          </div>
          <div>
            <label class="mb-[5px] text-[13px] text-[#5B5B5B]">Email Id<span class="text-[red]">*</span></label>
            <input type="text" formControlName="email"
              class="w-full border-solid border-[1px] mt-[8px] rounded-md border-[#BCBCBC] px-3 py-3 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-1 focus:border-gray-900 focus:border-t-transparent focus:!border-t-gray-900 focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50" />
            @if(userQuoteForm?.get('email')?.invalid && userQuoteForm?.get('email')?.touched){
            <div>
              <small class="text-red-500 text-[12px]">Email is required and must be valid.</small>
            </div>
            }
          </div>
        </div>
        <div class="grid md:grid-cols-3 grid-cols-1 gap-[20px] mb-[20px]">
          <div>
            <label class="mb-[5px] text-[13px] text-[#5B5B5B]">Company Name<span class="text-[red]">*</span></label>
            <input type="text" formControlName="company"
              class="w-full border-solid border-[1px] mt-[8px] rounded-md border-[#BCBCBC] px-3 py-3 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-1 focus:border-gray-900 focus:border-t-transparent focus:!border-t-gray-900 focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50" />
            @if(userQuoteForm?.get('company')?.invalid && userQuoteForm?.get('company')?.touched){
            <div>
              @if(userQuoteForm?.get('company')?.errors?.['maxlength']){
              <small class="text-red-500 text-[12px]">Company name cannot exceed 50 characters.</small>
              } @else {
              <small class="text-red-500 text-[12px]">Company name is required.</small>
              }
            </div>
            }
          </div>
          <div>
            <label class="mb-[5px] text-[13px] text-[#5B5B5B]">GST Number</label>
            <input type="text" formControlName="gst"
              class="w-full border-solid border-[1px] mt-[8px] rounded-md border-[#BCBCBC] px-3 py-3 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-1 focus:border-gray-900 focus:border-t-transparent focus:!border-t-gray-900 focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50" />
            @if(userQuoteForm?.get('gst')?.invalid && userQuoteForm?.get('gst')?.touched){
            <div>
              <small class="text-red-500 text-[12px]">Please enter a valid GST number.</small>
            </div>
            }
          </div>
          <div>
            <label class="mb-[5px] text-[13px] text-[#5B5B5B]">Address</label>
            <input type="text" formControlName="address"
              class="w-full border-solid border-[1px] mt-[8px] rounded-md border-[#BCBCBC] px-3 py-3 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-1 focus:border-gray-900 focus:border-t-transparent focus:!border-t-gray-900 focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50" />
            @if(userQuoteForm?.get('address')?.invalid && userQuoteForm?.get('address')?.touched){
            <div>
              @if(userQuoteForm?.get('address')?.errors?.['minlength']){
              <small class="text-red-500 text-[12px]">Address must be at least 10 characters.</small>
              } @else if(userQuoteForm?.get('address')?.errors?.['maxlength']){
              <small class="text-red-500 text-[12px]">Address cannot exceed 200 characters.</small>
              } @else {
              <small class="text-red-500 text-[12px]">Address can only contain letters, numbers, spaces and , . - / # & '</small>
              }
            </div>
            }
          </div>
        </div>
        <div class="grid md:grid-cols-3 grid-cols-1 gap-[20px] mb-[20px]">
          <div>
            <label class="mb-[5px] text-[13px] text-[#5B5B5B]">Landmark</label>
            <input type="text" formControlName="landmark"
              class="w-full border-solid border-[1px] mt-[8px] rounded-md border-[#BCBCBC] px-3 py-3 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-1 focus:border-gray-900 focus:border-t-transparent focus:!border-t-gray-900 focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50" />
            @if(userQuoteForm?.get('landmark')?.invalid && userQuoteForm?.get('landmark')?.touched){
            <div>
              @if(userQuoteForm?.get('landmark')?.errors?.['minlength']){
              <small class="text-red-500 text-[12px]">Landmark must be at least 5 characters.</small>
              } @else if(userQuoteForm?.get('landmark')?.errors?.['maxlength']){
              <small class="text-red-500 text-[12px]">Landmark cannot exceed 30 characters.</small>
              } @else {
              <small class="text-red-500 text-[12px]">Landmark can only contain letters, numbers, spaces and , . - / # & '</small>
              }
            </div>
            }
          </div>
          <div>
            <label class="mb-[5px] text-[13px] text-[#5B5B5B]">Pincode<span class="text-[red]">*</span>
            </label>
            <input (input)="checkPincodeDetails()" type="text" formControlName="zipcode"
              class="w-full border-solid border-[1px] mt-[8px] rounded-md border-[#BCBCBC] px-3 py-3 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-1 focus:border-gray-900 focus:border-t-transparent focus:!border-t-gray-900 focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50" />
            @if((userQuoteForm?.get('zipcode')?.invalid && userQuoteForm?.get('zipcode')?.touched) || invalidPincode()){
            <div>
              <small class="text-red-500 text-[12px]">Pincode is required and must be valid.</small>
            </div>
            }
          </div>
          <div>
            <label class="mb-[5px] text-[13px] text-[#5B5B5B]">City<span class="text-[red]">*</span></label>
            <input type="text" formControlName="city"
              class="w-full border-solid border-[1px] mt-[8px] rounded-md border-[#BCBCBC] px-3 py-3 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-1 focus:border-gray-900 focus:border-t-transparent focus:!border-t-gray-900 focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50" />
          </div>
        </div>
        <div class="grid md:grid-cols-3 grid-cols-1 gap-[20px] mb-[20px]">
          <div>
            <label class="mb-[5px] text-[13px] text-[#5B5B5B]">State<span class="text-[red]">*</span></label>
            <input type="text" formControlName="state"
              class="w-full border-solid border-[1px] mt-[8px] rounded-md border-[#BCBCBC] px-3 py-3 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-1 focus:border-gray-900 focus:border-t-transparent focus:!border-t-gray-900 focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50" />
          </div>
          @if (showAgentId()) {
          <div>
            <label class="mb-[5px] text-[13px] text-[#5B5B5B]">Agent Id<span class="text-[red]">*</span></label>
            <input type="text" formControlName="agentId"
              class="w-full border-solid border-[1px] mt-[8px] rounded-md border-[#BCBCBC] px-3 py-3 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-1 focus:border-gray-900 focus:border-t-transparent focus:!border-t-gray-900 focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50" />
            @if(userQuoteForm?.get('agentId')?.invalid && userQuoteForm?.get('agentId')?.touched){
            <div>
              <small class="text-red-500 text-[12px]">Agent Id is required and must be valid.</small>
            </div>
            }
          </div>
          }
        </div>

        <div class="grid md:grid-cols-3 grid-cols-1 gap-[20px] mb-[20px]">
          <div class="flex align-center">
            <div class="flex items-center gap-2 leading-[23px]">
              <div>
                <input (change)="captureAgentId($event)" type="checkbox"
                  class="w-full border-solid border-[1px] mt-[8px] rounded-md border-[#BCBCBC] px-3 py-3 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-1 focus:border-gray-900 focus:border-t-transparent focus:!border-t-gray-900 focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50" />
              </div>
              <div>
                <label class="mb-[5px] text-[13px] text-[#000]">I am being assisted by an Agent</label>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="flex w-full gap-[20px] items-center justify-center flex-wrap md:flex-nowrap mb-[20px]">
        </div> -->
        @if(invalidForm()){
        <p class="text-[red] text-md flex items-center justify-center bottom-70 m-auto">
          {{ invalidForm() }}
        </p>
        }
        <div class="mt-[30px] m-auto w-full flex items-center justify-end">
          <button type="submit"
            class="bg-[#F94D00] text-[#ffffff] py-[15px] px-[25px] text-center rounded-[5px] font-semibold text-[16px] disabled:bg-[#eee] disabled:text-[#5f5f5f] md:w-auto w-full"
            [disabled]="userQuoteForm.invalid || fetchPincode()">
            SUBMIT REQUEST
          </button>
        </div>
      </div>
    </form>
  </div>
  <!-- commented for now -->
  <!--feq section start here-->
  <!-- <div
      class="shadow-md bg-[#ffffff] rounded-[5px] mb-[20px] p-[20px] max-w-[1200px] mx-auto"
    >
      <div class="max-w-[900px] m-auto">
        <div class="pl-[10px] pr-[10px]">
          <div
            class="text-[#162F4D] text-[18px] text-center font-semibold mb-[20px]"
          >
            Frequently Asked Question
          </div>
          <div class="py-3">
            <details class="group">
              <summary
                class="flex justify-between items-center font-medium cursor-pointer list-none bg-[#F4F6F8] p-[10px]"
              >
                <span>
                  Please read the following User Agreement carefully before
                  using or accessing the Platform or the Services:</span
                >
                <span class="transition group-open:rotate-180">
                  <svg
                    fill="none"
                    height="24"
                    class="text-[#F94D00]"
                    shape-rendering="geometricPrecision"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                    width="24"
                  >
                    <path d="M6 9l6 6 6-6"></path>
                  </svg>
                </span>
              </summary>
              <div
                class="border-[#eeeeee] border-solid border-[1px] border-t-[0px] p-[10px]"
              >
                <p
                  class="text-neutral-600 group-open:animate-fadeIn leading-[20px] text-[14px]"
                >
                  The following demonstrates the User Agreement (hereinafter
                  referred to as an "Agreement") between IB Monotaro Private
                  Limited, a company duly registered under the provisions of the
                  Companies Act, 2013, with its registered office at Khasra No:
                  401-402, First Floor. Ghitorni, Delhi - 110030 (India)
                  (hereinafter referred to as "Industrybuying") and the users of
                  the Platform (as defined below) ("You", "Your,
                  "User"/"Users").
                </p>
              </div>
            </details>
          </div>
          <div class="py-3">
            <details class="group">
              <summary
                class="flex justify-between items-center font-medium cursor-pointer list-none bg-[#F4F6F8] p-[10px]"
              >
                <span>
                  Please read the following User Agreement carefully before
                  using or accessing the Platform or the Services:</span
                >
                <span class="transition group-open:rotate-180">
                  <svg
                    fill="none"
                    height="24"
                    class="text-[#F94D00]"
                    shape-rendering="geometricPrecision"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                    width="24"
                  >
                    <path d="M6 9l6 6 6-6"></path>
                  </svg>
                </span>
              </summary>
              <div
                class="border-[#eeeeee] border-solid border-[1px] border-t-[0px] p-[10px]"
              >
                <p
                  class="text-neutral-600 group-open:animate-fadeIn leading-[20px] text-[14px]"
                >
                  The following demonstrates the User Agreement (hereinafter
                  referred to as an "Agreement") between IB Monotaro Private
                  Limited, a company duly registered under the provisions of the
                  Companies Act, 2013, with its registered office at Khasra No:
                  401-402, First Floor. Ghitorni, Delhi - 110030 (India)
                  (hereinafter referred to as "Industrybuying") and the users of
                  the Platform (as defined below) ("You", "Your,
                  "User"/"Users").
                </p>
              </div>
            </details>
          </div>
          <div class="py-3">
            <details class="group">
              <summary
                class="flex justify-between items-center font-medium cursor-pointer list-none bg-[#F4F6F8] p-[10px]"
              >
                <span>
                  Please read the following User Agreement carefully before
                  using or accessing the Platform or the Services:</span
                >
                <span class="transition group-open:rotate-180">
                  <svg
                    fill="none"
                    height="24"
                    class="text-[#F94D00]"
                    shape-rendering="geometricPrecision"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                    width="24"
                  >
                    <path d="M6 9l6 6 6-6"></path>
                  </svg>
                </span>
              </summary>
              <div
                class="border-[#eeeeee] border-solid border-[1px] border-t-[0px] p-[10px]"
              >
                <p
                  class="text-neutral-600 group-open:animate-fadeIn leading-[20px] text-[14px]"
                >
                  The following demonstrates the User Agreement (hereinafter
                  referred to as an "Agreement") between IB Monotaro Private
                  Limited, a company duly registered under the provisions of the
                  Companies Act, 2013, with its registered office at Khasra No:
                  401-402, First Floor. Ghitorni, Delhi - 110030 (India)
                  (hereinafter referred to as "Industrybuying") and the users of
                  the Platform (as defined below) ("You", "Your,
                  "User"/"Users").
                </p>
              </div>
            </details>
          </div>
          <div class="py-3">
            <details class="group">
              <summary
                class="flex justify-between items-center font-medium cursor-pointer list-none bg-[#F4F6F8] p-[10px]"
              >
                <span>
                  Please read the following User Agreement carefully before
                  using or accessing the Platform or the Services:</span
                >
                <span class="transition group-open:rotate-180">
                  <svg
                    fill="none"
                    height="24"
                    class="text-[#F94D00]"
                    shape-rendering="geometricPrecision"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                    width="24"
                  >
                    <path d="M6 9l6 6 6-6"></path>
                  </svg>
                </span>
              </summary>
              <div
                class="border-[#eeeeee] border-solid border-[1px] border-t-[0px] p-[10px]"
              >
                <p
                  class="text-neutral-600 group-open:animate-fadeIn leading-[20px] text-[14px]"
                >
                  The following demonstrates the User Agreement (hereinafter
                  referred to as an "Agreement") between IB Monotaro Private
                  Limited, a company duly registered under the provisions of the
                  Companies Act, 2013, with its registered office at Khasra No:
                  401-402, First Floor. Ghitorni, Delhi - 110030 (India)
                  (hereinafter referred to as "Industrybuying") and the users of
                  the Platform (as defined below) ("You", "Your,
                  "User"/"Users").
                </p>
              </div>
            </details>
          </div>
        </div>
      </div>
    </div> -->
</div>
}